import React, { useEffect, useState } from "react";
import { Chip, Grid, IconButton } from "@material-ui/core";
import { Close, Tune } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { useStyles } from "./CustomToolBar.styles";
import { FilterDropDown } from "../FilterDropDown/FilterDropDown";
import dayjs from "dayjs";

const CustomToolBar = ({
  initialFilters,
  timeFilter,
  setReportRangeFilter,
  reportRangeFilter,
  ...props
}) => {
  const classes = useStyles();
  const { t } = useTranslation(["common"]);

  const [selectedFilters, setSelectedFilters] = useState([]);
  const filterEmptyState = [{ column: "", value: "" }];
  const [opened, setOpened] = useState(false);
  const [reportRangeValue, setReportRangeValue] = useState();
  function setFilters(rowInstance) {
    const updatedFilters = rowInstance.filter(
      (row) => row?.column && row?.value
    );
    setSelectedFilters(updatedFilters);

    props.onFilterClick(updatedFilters);
  }

  const deleteRule = (indexForDelete) => {
    const updatedRows = [
      ...selectedFilters.filter(
        (rule, ruleIndex) => ruleIndex !== indexForDelete
      ),
    ];
    setFilters(updatedRows);
  };
  useEffect(() => {
    setReportRangeValue(reportRangeFilter?.label);
  }, [reportRangeFilter]);
  useEffect(() => {
    if (Object.keys(initialFilters).length !== 0) {
      let rows = [];
      Object.keys(initialFilters).forEach((key) => {
        const columnObject = props.filterItems.find(
          (item) => item.column === key
        );
        rows.push({
          column: columnObject,
          value:
            columnObject?.valueType === "select"
              ? columnObject?.selectableContents?.find(
                  (item) => item.code === initialFilters[key]
                )
              : columnObject?.valueType === "date"
              ? dayjs(parseInt(initialFilters[key])).toDate()
              : initialFilters[key],
        });
      });
      setSelectedFilters(rows);
    }
  }, [initialFilters, props.filterItems, opened]);

  function clearFilters() {
    setFilters([]);
  }

  return (
    <>
      <div className={classes.tableHeader} data-textid="filterDropdown">
        <Grid container spacing={1} alignItems="flex-end">
          <Grid item>
            <div className={classes.btnGrp}>
              <FilterDropDown
                icon={<Tune className={classes.rotateScale} />}
                label={t("common:dataGrid.filter")}
                filterItems={props.filterItems}
                applyFilters={setFilters}
                clearFilters={clearFilters}
                selectedFilters={
                  selectedFilters?.length ? selectedFilters : filterEmptyState
                }
                opened={setOpened}
                timeFilter={timeFilter}
                setReportRange={setReportRangeFilter}
                reportRange={reportRangeFilter}
              />
              <div className={classes.chipContainer}>
                {reportRangeValue && (
                  <Chip
                    icon={
                      <IconButton
                        aria-label="delete"
                        className={classes.iconBtn}
                        size="small"
                      >
                        <Close fontSize="inherit" />
                      </IconButton>
                    }
                    label={reportRangeValue}
                    onClick={() => {
                      setReportRangeFilter("");
                      setReportRangeValue("");
                    }}
                    className={classes.chip}
                    data-testid="clear-btn"
                  />
                )}
                {selectedFilters.map((data, i) => {
                  return (
                    <Chip
                      key={i}
                      icon={
                        <IconButton
                          aria-label="delete"
                          className={classes.iconBtn}
                          size="small"
                        >
                          <Close fontSize="inherit" />
                        </IconButton>
                      }
                      label={
                        data?.column?.valueType === "select"
                          ? data?.value?.value
                          : data?.column?.valueType === "date"
                          ? dayjs(data?.value).format("DD/MM/YYYY")
                          : data?.value
                      }
                      onClick={() => {
                        deleteRule(i);
                      }}
                      className={classes.chip}
                      data-testid="toolbar-chip"
                    />
                  );
                })}
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

CustomToolBar.propTypes = {
  initialFilters: PropTypes.object,
  onFilterClick: PropTypes.func,
  filterItems: PropTypes.array,
  timeFilter: PropTypes.array,
  setReportRangeFilter: PropTypes.func,
  reportRangeFilter: PropTypes.object,
};

export { CustomToolBar };
